module.exports = __webpack_public_path__ + "img/build-spalling-inspection.8dac535a.jpg";